<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong id="pageTitle">Register of Dividend Mandate</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/dividendMandateList"> -->
        <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>
    <!-- <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="addBtn">
        <span>
          <i class="fa fa-save"></i>Generate Output</span>
      </button>
</span> -->
  </div>

  <div class="card-block">
    <form [formGroup]="dmForm" (document:click)="a.close();b.close();c.close();d.close();e.close();f.close();g.close()">
      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Percentage of Dividend Declared</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.percDdec">
          <div *ngIf="dmForm.controls['percDdec'].hasError('pattern')" class="form-control-error-custom">
            Percentage of Dividend Declared is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of Book Closure</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.doBookClosure" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" [(ngModel)]="dateOfBookClosure" name="dateOfBookClosure" ngbDatepicker
              #a="ngbDatepicker" (click)="a.toggle()">
            <button class="input-group-addon"
              (click)="a.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Record Date</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.recordDate" name="recordDate"
              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" [(ngModel)]="recordDate" ngbDatepicker
              #b="ngbDatepicker"
              (click)="b.toggle()">
            <button class="input-group-addon"
              (click)="b.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of Declaration</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.doDeclaration" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" [(ngModel)]="dateOfDeclaration" name="dateOfDeclaration" ngbDatepicker
              #c="ngbDatepicker" (click)="c.toggle()">
            <button class="input-group-addon" (click)="c.toggle()"
              type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Due Date of Payment of Dividend</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.dueDpayDivident" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" [(ngModel)]="dueDateOfPayment" name="dueDateOfPayment" ngbDatepicker
              #d="ngbDatepicker" (click)="d.toggle()">
            <button class="input-group-addon"
              (click)="d.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Date of Transfer to or Opening of Separate Bank Account</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.doTransferorOpenSeperateBA"
              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" [(ngModel)]="dateOfTransfer"
              name="dateOfTransfer" ngbDatepicker #e="ngbDatepicker"
              (click)="e.toggle()">
            <button class="input-group-addon"
              (click)="e.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>
      </div>





      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Name of Member</label>
          <span _ngcontent-c1="" style="color: red;">*</span>
          <input type="text" class="form-control" [formControl]="dmForm.controls.nameofMember">
          <div *ngIf="dmForm.controls['nameofMember'].hasError('pattern')" class="form-control-error-custom ">
            Name of Member is invalid
          </div>
          <div *ngIf="dmForm.controls['nameofMember'].hasError('required') && dmForm.controls['nameofMember'].touched"
            class="form-control-error-custom">
            Name of Member is required
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Number of Shares held</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.noOfSharesheld">
          <div *ngIf="dmForm.controls['noOfSharesheld'].hasError('pattern')" class="form-control-error-custom ">
            Number of Shares held is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Folio Number</label>
          <span _ngcontent-c1="" style="color: red;">*</span>
          <input type="text" class="form-control" [formControl]="dmForm.controls.folioNumber">
          <div *ngIf="dmForm.controls['folioNumber'].hasError('pattern')" class="form-control-error-custom ">
            Folio Number is invalid
          </div>
          <div *ngIf="dmForm.controls['folioNumber'].hasError('required') && dmForm.controls['folioNumber'].touched"
            class="form-control-error-custom">
            Folio Number is required
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Address of Member</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.addresofMembers">
          <div *ngIf="dmForm.controls['addresofMembers'].hasError('pattern')" class="form-control-error-custom">
            Address of Member is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Bank Account Number, where the dividend to be credited</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.bankaccountnumber" maxlength="20">
          <div
            *ngIf="(dmForm.controls['bankaccountnumber'].hasError('minlength') || dmForm.controls['bankaccountnumber'].hasError('maxlength')) && dmForm.controls['bankaccountnumber'].touched"
            class="form-control-error-custom ">
            Bank Account Number is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>IFSC code of the Bank / Branch</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.ifscOrOtherMandatoryInformation">
          <div *ngIf="dmForm.controls['ifscOrOtherMandatoryInformation'].hasError('pattern')"
            class="form-control-error-custom">
            IFSC code of the Bank / Branch is invalid
          </div>
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Address of the Bank Branch, where the dividend to be credited</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.aoBBwhereDividendtobeCredited">
          <div *ngIf="dmForm.controls['aoBBwhereDividendtobeCredited'].hasError('pattern')"
          class="form-control-error-custom">
          Address of the Bank Branch, where the dividend to be credited is invalid
        </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Amount paid on the Shares</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.amountPaidontheShares">
          <div *ngIf="dmForm.controls['amountPaidontheShares'].hasError('pattern')" class="form-control-error-custom">
            Amount paid on the Shares is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Dividend Payable</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.dividendPayable">
          <div *ngIf="dmForm.controls['dividendPayable'].hasError('pattern')" class="form-control-error-custom">
            Dividend Payable is invalid
          </div>
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Dividend Warrant Number</label>
          <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-12">
              <label>From</label>
              <input type="text" class="form-control" (keydown)="onlyNumber($event)"
                [formControl]="dmForm.controls.dividendWarrantNumberFrom">
              <div *ngIf="dmForm.controls['dividendWarrantNumberFrom'].hasError('pattern')"
                class="form-control-error-custom">
                Dividend Warrant Number From is invalid
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <label>To</label>
              <input type="text" class="form-control" (keydown)="onlyNumber($event)"
                [formControl]="dmForm.controls.dividendWarrantNumberTo">
              <div *ngIf="dmForm.controls['dividendWarrantNumberTo'].hasError('pattern')"
                class="form-control-error-custom">
                Dividend Warrant Number To is invalid
              </div>
            </div>

          </div>

        </div>


        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label class="form-group">Date of Payment</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.doPayment" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" [(ngModel)]="dateOfPayment" name="dateOfPayment" ngbDatepicker #f="ngbDatepicker"
              (click)="f.toggle()">
            <button class="input-group-addon"
              (click)="f.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12"><br>
          <label>Mode of Payment</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.modeofPayment">
          <div *ngIf="dmForm.controls['modeofPayment'].hasError('pattern')" class="form-control-error-custom">
            Mode of Payment is invalid
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Interim Dividend</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.interimDividend">
          <div *ngIf="dmForm.controls['interimDividend'].hasError('pattern')" class="form-control-error-custom">
            Interim Dividend is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Final Dividend</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.finalDividend">
          <div *ngIf="dmForm.controls['finalDividend'].hasError('pattern')" class="form-control-error-custom">
            Final Dividend is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Dividend kept in abeyance</label>
          <input type="text" class="form-control" (keydown)="onlyNumber($event)"
            [formControl]="dmForm.controls.dividendKeptinAbeyance">
          <div *ngIf="dmForm.controls['dividendKeptinAbeyance'].hasError('pattern')" class="form-control-error-custom">
            Dividend kept in abeyance is invalid
          </div>
        </div>
      </div>



      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Name of the person to whom dividend should be paid</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.nopToWhomDividendShoudbePaid">
          <div *ngIf="dmForm.controls['nopToWhomDividendShoudbePaid'].hasError('pattern')"
            class="form-control-error-custom">
            Name of the person is invalid
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label class="form-group">Date of Mandate</label>
          <div class="input-group" (click)="$event.stopPropagation()">
            <input class="form-control" [formControl]="dmForm.controls.doMandate" style="padding:6px;z-index: 0;"
              placeholder="dd-mm-yyyy" [(ngModel)]="dateOfMandate" name="dateOfMandate" ngbDatepicker #g="ngbDatepicker"
              (click)="g.toggle()">
            <button class="input-group-addon"
              (click)="g.toggle()" type="button">
              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
            </button>
          </div>
        </div>

        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Court order, if any</label>
          <input type="text" class="form-control" [formControl]="dmForm.controls.courtOrderIfany">
          <div *ngIf="dmForm.controls['courtOrderIfany'].hasError('pattern')" class="form-control-error-custom">
            Court order, if any is invalid
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4 col-sm-6 col-xs-12">
          <label>Remarks, if any</label>
          <textarea class="form-control" [formControl]="dmForm.controls.remarks"></textarea>
          <div *ngIf="dmForm.controls['remarks'].hasError('pattern')" class="form-control-error-custom">
            Remarks, if any is invalid
          </div>
        </div>

      </div>
    </form>
  </div>


  <div class="card-footer" align="right">
    <div class="form-group" *ngIf="!addBtn">
      <button class="btn btn-sm btn-primary" (click)="saveData()" type="button" [disabled]="!(dmForm.valid) || disabledOnclick">
        <span> <i class="fa fa-save"></i>&nbsp;Save </span> </button>
    </div>
    <div class="form-group" *ngIf="addBtn">
      <button class="btn btn-sm btn-primary" (click)="updateData(editDividendId._id)" type="button"
        [disabled]="!(dmForm.valid) || disabledOnclick">
        <span> <i class="fa fa-save"></i>&nbsp;Update </span>
      </button>
    </div>
  </div>

</section>